import { desiredOrder } from '@epi-constants/beneficiary';
import { TODAY } from '@epi-constants/downloadReports';
import { FormFields } from '@epi-forms/helpers';
import { IBenefitMaxAmounts } from '@epi-models/containers/ManageBenefitGroups';
import {
  BeneficiaryFormValues,
  IBeneficiaryData
} from '@epi-models/pages/Beneficiaries';

const sortBenefitsByCustomOrder = (arr, desiredOrder) => {
  const orderForIndexVals = [...desiredOrder].slice(0).reverse();
  return [...arr].sort((a, b) => {
    const aIndex = -orderForIndexVals.indexOf(a.benefitType);
    const bIndex = -orderForIndexVals.indexOf(b.benefitType);
    return aIndex - bIndex;
  });
};

const checkIfAnyBenefitValueExists = (benefits: IBenefitMaxAmounts) =>
  Object.values(benefits).some(val => val > 0);

export const benefitsDataMapper = (
  beneficiary: IBeneficiaryData,
  editingMode: boolean,
  isLunchBenefitActive?: boolean
) => {
  const {
    personId,
    firstName,
    lastName,
    emailAddress,
    personalId,
    endOfBenefit,
    endOfFunds,
    createdAt,
    employmentType,
    benefitGroupSettings,
    costCenter,
    employeeNumber,
    startOfBenefit,
    benefitPercentage,
    benefitLunchMaxWorkingDays,
    pendingLoadDate
  } = beneficiary;
  return {
    [FormFields.FirstName]: firstName ?? '',
    [FormFields.LastName]: lastName ?? '',
    [FormFields.PersonID]: personId?.toString() ?? '',

    [FormFields.EmailAddress]: emailAddress ?? '',
    [FormFields.PersonalID]: personalId ?? '',

    [FormFields.EndOfBenefit]: endOfBenefit ?? '',
    [FormFields.EndOfFunds]: endOfFunds ?? '',
    [FormFields.CreatedAt]: createdAt ?? '',

    [FormFields.EditMode]: editingMode,
    [FormFields.EditingType]: false,

    [FormFields.Entitled]: startOfBenefit ?? '',

    [FormFields.Benefits]: sortBenefitsByCustomOrder(
      benefitGroupSettings ?? [],
      desiredOrder
    ),

    [FormFields.EmployeeType]: employmentType ?? '',
    [FormFields.EmployeeNumber]: employeeNumber ?? '',
    [FormFields.CostCenterNumber]: costCenter ?? '',

    [FormFields.EmployeePercentage]: benefitPercentage ?? '',

    [FormFields.DaysForLunari]: benefitLunchMaxWorkingDays ?? '',

    [FormFields.LunchBenefitActive]: isLunchBenefitActive ?? false,

    [FormFields.PendingLoadDate]: pendingLoadDate ?? ''
  } as BeneficiaryFormValues;
};

export const setBenefitsDataForCreateEmployee = (
  benefits: IBenefitMaxAmounts
) =>
  Object.entries(benefits)
    .filter(([_, value]) => value > 0)
    .map(([benefitType, value], index) => ({
      groupId: benefitType + index,
      benefitType,
      maxAmountPerPeriod: value / 100,
      endDate: '',
      deductionType: '',
      frequency: '',
      mobilePaymentEnabled: false,
      name: benefitType,
      startDate: ''
    }));

export const addBenefitsDataMapper = (
  benefitMaxAmounts?: IBenefitMaxAmounts,
  isLunchBenefitActive?: boolean
) =>
  ({
    [FormFields.FirstName]: '',
    [FormFields.LastName]: '',
    [FormFields.PersonalID]: '',
    [FormFields.EmailAddress]: '',
    [FormFields.EmployeeNumber]: '',
    [FormFields.CostCenterNumber]: '',
    [FormFields.EndOfBenefit]: '',
    [FormFields.EndOfFunds]: '',
    [FormFields.EmployeeType]: '',
    [FormFields.EmployeePercentage]: '',
    [FormFields.EditingType]: false,
    [FormFields.LunchBenefitActive]: isLunchBenefitActive,
    [FormFields.Entitled]: '',
    [FormFields.Benefits]:
      benefitMaxAmounts && checkIfAnyBenefitValueExists(benefitMaxAmounts)
        ? setBenefitsDataForCreateEmployee(benefitMaxAmounts)
        : []
  } as BeneficiaryFormValues);

export const disableSaveButtonForBeneficiariesDataModal = (
  date: null | Date,
  isEntitledDate = false
) => {
  if (date === null) {
    return isEntitledDate;
  }

  if (date) {
    return date?.getTime() < TODAY.setHours(0, 0, 0, 0);
  }

  return true;
};
